// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'AIzaSyC4s_Drfpo3xrnjCTqkFtGt-OPFl5KjYOA',
  authDomain: 'clone-c885b.firebaseapp.com',
  projectId: 'clone-c885b',
  storageBucket: 'clone-c885b.appspot.com',
  messagingSenderId: '139760945227',
  appId: '1:139760945227:web:451c8ac82d20d0181765ce',
  measurementId: 'G-QEQFZ2PBTL',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
